@if (selectedService) {
  <section class="service-detail service-page">
    <div class="content">
      @if (browserSize === 'small') {
        <div class="back-heading">
          <a class="back-link icon-text" [routerLink]="['/services']">
            <div class="custom-icon arrow_back"></div>
            Back to Services
          </a>
        </div>
      }
      <div class="service-detail-content">
        <div class="service-detail-header">
          <div class="service-title">
            <h2>
              <mat-icon class="scale-90">directions_run</mat-icon>
              Service Details
            </h2>
          </div>
          <div class="service-status">
            <div class="status-wrapper">
              Status:
              <div class="status-container">
                <span
                  [ngClass]="{
                    open: selectedService.Status__c == 'In Service',
                    pending:
                      selectedService.Status__c == 'New' ||
                      selectedService.Status__c == 'Pending',
                    closed:
                      selectedService.Status__c == 'Canceled' ||
                      selectedService.Status__c == 'Disconnected',
                  }"
                >
                  {{
                    selectedService.Status__c === 'New'
                      ? 'Pending'
                      : selectedService.Status__c
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="service-detail-header">
          <div class="location-address">
            <div class="custom-icon location_dark">location icon</div>
            @if (selectedService.CustomerLocationAlias) {
              <span>{{ selectedService.CustomerLocationAlias }}</span>
            }
            {{ selectedService.Z_Location__r.Name }}
            @if (
              selectedService.Status__c === 'In Service' &&
              selectedService.BanLookupId
            ) {
              <a
                (click)="onEditLocationName(selectedService)"
                class="cursor-pointer p-2.5 pr-0 hover:rounded-full hover:bg-gray-50 focus:outline-none focus:ring-0"
                ><div class="custom-icon edit">edit</div></a
              >
            }
          </div>
        </div>
      </div>

      <div class="service-details">
        <div class="detail-wrapper">
          <div class="custom-icon circuit_dark">circuit icon</div>
          SERVICE: <span>{{ selectedService.Name | uppercase }}</span>
        </div>
        <div class="type-details">
          <div class="type">
            <span>Type:</span> {{ selectedService.RecordType.Name }}
          </div>
          @if (selectedService.Bandwidth_Downstream__c) {
            <div class="bandwidth">
              <span>Bandwidth: </span>
              {{ selectedService.Bandwidth_Downstream__c }}
              @if (selectedService.Asymmetrical_Bandwidth__c) {
                / {{ selectedService.Bandwidth_Upstream__c }}
              }
            </div>
          }
          @if (selectedService.Vendor__r) {
            <div class="vendor">
              <span>Vendor:</span>
              {{
                selectedService.Vendor__r.Display_Alias__c
                  ? selectedService.Vendor__r.Display_Alias__c
                  : selectedService.Vendor__r.Name
              }}
            </div>
          }
          @if (selectedService.Connector_Type_Z_Location__c) {
            <div class="connection-type">
              <span>Connector Type: </span>
              {{ selectedService.Connector_Type_Z_Location__c }}
            </div>
          }
        </div>
        <div class="date-details">
          @if (selectedService.Term__c) {
            <div class="term">
              <span>Term: </span> {{ selectedService.Term__c }} months
            </div>
          }
          <div class="start">
            <span>Start:</span>
            {{ selectedService.Start_Of_Service__c | date: 'M/d/yy' }}
          </div>
          <div class="end">
            <span>End:</span>
            {{ selectedService.Current_Term_End_Date__c | date: 'M/d/yy' }}
          </div>
        </div>
      </div>

      @if (selectedService.Components__r) {
        <div class="billing-component-wrapper">
          <app-service-billing
            [components]="selectedService.Components__r.records"
          ></app-service-billing>
        </div>
      }

      <div class="billing-total">
        Monthly Charges:
        <span>{{
          selectedService.MRR__c
            ? (selectedService.MRR__c | currency)
            : (0.0 | currency)
        }}</span>
      </div>

      @if (selectedService.Status__c === 'In Service') {
        <div
          class="button-wrapper"
          *ngxPermissionsOnly="Permission.TICKETING_WRITE"
        >
          <button class="primary-button" (click)="onCreateTicket()">
            Create Ticket
          </button>
        </div>
      }
    </div>

    <app-footer></app-footer>
  </section>
}
